import { useId } from 'react';

import styles from './enrollment.module.css';

export interface SelectOption {
  readonly value: string;
  readonly label: string;
}

export interface SelectFieldProps {
  readonly label: string;
  readonly value: string;
  readonly options: readonly SelectOption[];
  readonly required?: boolean;
  readonly placeholder?: string | undefined;
  readonly onChange: (value: string) => void;
}

/**
 * Select com rotulo associado por `htmlFor`.
 *
 * Nao vira primitivo de design nesta onda: os primitivos sao compartilhados
 * pela SPA inteira e promover um componente ao diretorio de design e decisao de
 * quem cuida do design system, nao efeito colateral de uma tela de cadastro.
 */
export function SelectField({
  label,
  value,
  options,
  required = false,
  placeholder,
  onChange,
}: SelectFieldProps) {
  const id = useId();

  return (
    <div className={styles.field}>
      <label className={styles.fieldLabel} htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className={styles.select}
        required={required}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {placeholder === undefined ? null : <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
